import { Link } from 'react-router';
import { ContentTitle } from '../../components/typography/Heading';
import styles from './project-sharing.module.less';
import { useTitle } from 'hoofd';

export const ProjectSharingHeader = ({ backLink, backLinkText, title, showLinks = true }) => {
    useTitle(title);
    return (
        <>
            {showLinks ? (
                <Link className={styles.navigationLink} to={backLink}>
                    ← {backLinkText}
                </Link>
            ) : null}
            <ContentTitle tag={'h1'} className={styles.title}>
                {title}
            </ContentTitle>
        </>
    );
};
